import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useMobile } from 'utils/media';
import { Outlet, Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import bem from 'utils/bem';
import { GoBack } from '../Page';
import Icon from 'components/Icon';
import Text from 'components/Text';
import Tabs from 'components/Tabs';
import Model from '../../../model';

import './index.sass';
import { toast } from 'react-hot-toast';

const { block, el } = bem( 'page', 'office' );

const tabs = [
    {
        label: 'Профиль',
        to: '/profile',
        component: Link
    },
    {
        label: 'Записи',
        to: '/orders',
        component: Link
    },
    {
        label: 'Покупки',
        to: '/items',
        component: Link
    }
]

const Office = () => {

    const { isMobile } = useMobile();
    const { isKZ } = Model.kz;
    const { openFinishPaymentModal } = Model.modal;
    const { state } = useLocation();

    useEffect(() => {
        if ( state?.response ) {
            const { response } = state;
            if ( response.error ) {
                toast.error( `Ошибка при проверке статуса оплаты: ${ response?.error_text }`);
            }
            if ( response.success ) {
                openFinishPaymentModal(response);
            } else {
                toast.error( `${ response.status }: ${ response.text_status }`);
            }
        }
    }, [state])

    return (
        <div className={ block() } >
            <div className={el('top-block')}>
                <div className={el('header')}>
                    <GoBack />
                </div>
                <div className={el('title-block')}>
                    <div className={el('office-title')}>
                        <Text serif>Личный кабинет</Text>
                    </div>
                    <div className={el('title-block-right')}>
                        { !isMobile && isKZ && <a className={el('foreign-payments')} href={'/foreign-payments'} >
                            <Text serif>Оплата иностранными картами</Text>
                            <Icon name={'question'} />
                        </a> }
                        { !isMobile && <a className={el('logout')} href={'/logout'} >
                            <Text serif>Выйти из аккаунта</Text>
                            <Icon name={'arrow-line-up-right'} />
                        </a> }
                    </div>
                </div>
            </div>
            <div className={el('tabs-block')}>
                <div className={el('tabs')}>
                    <Tabs tabs={tabs}/>
                </div>
            </div>
            <div className={el('content')}>
                <Outlet />
            </div>
            { isMobile && <a className={el('logout')} href={'/logout'} >
                <Text serif>Выйти из аккаунта</Text>
                <Icon name={'arrow-line-up-right'} />
            </a> }
            { isMobile && isKZ && <a className={el('foreign-payments')} href={'/foreign-payments'} >
                <Text serif>Оплата иностранными картами</Text>
                <Icon name={'question'} />
            </a> }
        </div>
    );
};

export default observer(Office);


